import {
  Avatar,
  Button,
  Col,
  message,
  Result,
  Row,
  Space,
  Typography,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import FAQOptionsList from "./FAQOptionsList";
import { UserOutlined, LeftOutlined, CloseOutlined } from "@ant-design/icons";
import api from "utils/api";
import PatientConversation from "Components/PatientConversation";
import Icons from "Common/Icons";
import ChatFeedback from "./ChatFeedback";
import AIBotChat from "./AIBotChat";
import { useDispatch, useSelector } from "react-redux";
import { AI_BOT_CHAT_TYPE } from "Common/constant";
import { LIVE_CHAT_TYPE } from "Common/constant";
import { clearAiBotChatDetails } from "store/slice/aichat-slice";
import Loader from "Components/Loader";
import { setAiBotChatDetails } from "store/slice/aichat-slice";
import { LiveChatLoadIcon } from "Common/ReactIcons";

const transformChatInitOptns = (data) => {
  let transformedData = data.map((item) => ({
    category: item.category,
    option: item.option,
  }));
  return transformedData;
};

const PatientChatHomePage = ({
  closeChatWindow,
  isLiveChatOpen,
  isAiBotChatOpen,
  chatDetails,
  clearChatDetails,
  clearAiBotChatDtls,
}) => {
  const [chatType, setChatType] = useState(null);
  const [liveChatId, setLiveChatId] = useState(null);
  const [aiBotChatId, setAiBotChatId] = useState(null);
  const [isCreatingLiveChat, setCreatingLiveChat] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isGoBack, setIsGoBack] = useState(false);
  const [isLiveChatClosed, setLiveChatClosed] = useState(false);
  const [careAdminName, setCareAdminName] = useState(null);
  const [sltdFAQOption, setSltdFAQOption] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAiBotChatExist, setAiBotChatExist] = useState(false);
  const [aiBotChatStatus, setAiBotChatStatus] = useState(null);
  const [faqDetails, setFAQDetails] = useState(null);
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);
  const [isFdbkEligible, setFdbkEligible] = useState(false);

  const aiBotChatIdBckupRef = useRef(null);
  const faqDetailsBckupRef = useRef(null);
  const chatDetailsBckupRef = useRef(null);

  const dispatch = useDispatch();

  const retainedAiBotChatDetails = useSelector(
    (state) => state.aiChatReducer.aiBotChatDetails
  );

  const openAiBotChat = () => {
    setChatType(AI_BOT_CHAT_TYPE);
    setFdbkEligible(true);
  };

  const openLiveChat = () => {
    setChatType(LIVE_CHAT_TYPE);
    setFdbkEligible(false);
    closeAiBotChat();
    clearAiBotChatDetails();
  };

  const gotoMainMenu = () => {
    if (chatType == LIVE_CHAT_TYPE && liveChatId && !isLiveChatClosed) {
      setShowPrompt(true);
      setIsGoBack(true);
    } else {
      setChatType(null);
      clearAiBotChatDtls();
    }
  };

  const updateLiveChatInit = (value) => {
    setCreatingLiveChat(value);
  };

  const updateCareAdminName = (value) => {
    setCareAdminName(value);
  };

  const updateLiveChatClose = () => {
    setLiveChatId(null);
    setLiveChatClosed(true);
  };

  const closeLiveChat = () => {
    let chat_id = liveChatId ?? chatDetails?.chat_id;
    if (chat_id && !isLiveChatClosed) {
      api
        .close_chat({ chat_id: chat_id })
        .then((res) => {
          setLiveChatId(null);
          // message.success("Chat Closed Successfully");
        })
        .catch((error) => {
          message.error("Error in chat close", ErrorDuration);
        });
    }
  };

  const closeAiBotChat = () => {
    if (aiBotChatId) {
      api
        .close_chat_bot({ chat_id: aiBotChatId })
        .then((res) => {
          // message.success("Chat Closed Successfully");
          // setLiveChatId(null);
        })
        .catch((error) => {
          message.error("Error in chat close", ErrorDuration);
        });
    }
  };

  const closeLiveChatWindow = () => {
    setShowPrompt(false);
    closeLiveChat();
    setLiveChatId(null);
    if (isGoBack) {
      setChatType(null);
      setCareAdminName(null);
      if (!faqDetails) {
        setAiBotChatId(retainedAiBotChatDetails?.aiBotChatId);
        setFAQDetails(retainedAiBotChatDetails?.faqOptionsList);
      }
    } else {
      dispatch(clearAiBotChatDetails());
      // closeAiBotChat();
      closeChatWindow();
    }
  };

  const handleClose = (val) => {
    if (liveChatId && !isLiveChatClosed) {
      setShowPrompt(true);
      setIsGoBack(false);
    } else {
      if (!isFeedbackOpen && isFdbkEligible) {
        setFeedbackOpen(true);
      } else {
        closeAiBotChat();
        closeChatWindow();
      }
      clearAiBotChatDtls();
      dispatch(clearAiBotChatDetails());
    }
  };

  const updateLiveChatId = (id) => {
    setLiveChatId(id);
  };

  const startAiBotChat = (status = null) => {
    setLoading(true);
    let data = {
      chat_status: status ?? aiBotChatStatus,
    };
    api
      .start_chat_bot(data)
      .then((res) => {
        let { chat_id, buttons_response } = res.data?.data;
        buttons_response = buttons_response.filter(item => item.category !== "/assessment");
        let tmpData = transformChatInitOptns(buttons_response);
        setAiBotChatId(chat_id);
        aiBotChatIdBckupRef.current = chat_id;
        setFAQDetails(tmpData);
        faqDetailsBckupRef.current = tmpData;
        setAiBotChatExist(false);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const takeAiBotChatBckup = () => {
    aiBotChatIdBckupRef.current = retainedAiBotChatDetails?.aiBotChatId;
    faqDetailsBckupRef.current = retainedAiBotChatDetails?.faqOptionsList;
    chatDetailsBckupRef.current = retainedAiBotChatDetails?.aiBotChatData;
  };

  useEffect(() => {
    if (isLiveChatOpen) {
      setChatType(LIVE_CHAT_TYPE);
      setLiveChatId(chatDetails?.chat_id);
      setCareAdminName(chatDetails?.care_admin_name);
      setLoading(false);
    } else if (
      isAiBotChatOpen &&
      retainedAiBotChatDetails?.aiBotChatData?.length > 0
    ) {
      setChatType(AI_BOT_CHAT_TYPE);
      setFdbkEligible(true);
      setAiBotChatId(retainedAiBotChatDetails?.aiBotChatId);
      setLoading(false);
    } else if (isAiBotChatOpen && !retainedAiBotChatDetails?.aiBotChatData) {
      setAiBotChatId(retainedAiBotChatDetails?.aiBotChatId);
      setFAQDetails(retainedAiBotChatDetails?.faqOptionsList);
      setLoading(false);
    } else {
      api
        .check_chat_bot_status()
        .then((res) => {
          let { chat_status } = res.data?.data;
          if (chat_status == "inprogress") {
            setAiBotChatStatus(chat_status);
            setAiBotChatExist(true);
            setLoading(false);
          } else {
            startAiBotChat(chat_status);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    }

    if (retainedAiBotChatDetails?.aiBotChatId) {
      takeAiBotChatBckup();
    }

    const handleBeforeUnload = () => {
      dispatch(
        setAiBotChatDetails({
          aiBotChatId: aiBotChatIdBckupRef.current,
          aiBotChatData: chatDetailsBckupRef.current,
          faqOptionsList: faqDetailsBckupRef.current,
        })
      );
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div className="chat-parent-section">
      <div
        className={`chat-header-section img-header ${
          chatType ? "h-14" : "h-20"
        }`}
        // className={`chat-header-section ${
        //   chatType != LIVE_CHAT_TYPE ? "img-header" : "live-chat-header"
        // }`}
      >
        <Row
          className="patient-chat-header"
          // align="middle"
        >
          {chatType != LIVE_CHAT_TYPE && !isFeedbackOpen && (
            <Col span={21} className="care-navigator-patient">
              <Space>
                <Avatar
                  size={50}
                  style={{
                    backgroundColor: "#BFBFBF",
                  }}
                  icon={<UserOutlined />}
                />
                <div>
                  <Typography className="careadmin-name">I'm Alisa</Typography>
                  <span className="care-role-txt">Care Navigator</span>
                </div>
              </Space>
            </Col>
          )}
          {isFeedbackOpen && (
            <Col span={21} className="care-navigator-patient">
              <div>
                <div className="feedback-rate-header-txt">
                  Leave Your Feedback
                </div>
                <div className="feedback-rate-sub-header-txt">
                  Your valuable rating is important to us
                </div>
              </div>
            </Col>
          )}
          {chatType == LIVE_CHAT_TYPE && !isFeedbackOpen && (
            <Col span={21} className="care-navigator-patient">
              {careAdminName ? (
                <Space>
                  <Avatar
                    size={50}
                    style={{
                      backgroundColor: "#BFBFBF",
                    }}
                    icon={<UserOutlined />}
                  />
                  <div>
                    <Typography className="careadmin-name">
                      I'm {careAdminName}
                    </Typography>
                    <span>Care Admin</span>
                  </div>
                </Space>
              ) : (
                <Space>
                  <LiveChatLoadIcon />
                  <div className="live-chat-header-txt">Live Chat</div>
                </Space>
              )}
            </Col>
          )}
          <Col
            span={3}
            className={`close-icon-chat ${
              chatType ? "centered-close-icon" : "mt-12"
            }`}
          >
            {isCreatingLiveChat ? (
              <CloseOutlined className="disabled-close" />
            ) : (
              <CloseOutlined className="close-icon-svg" onClick={handleClose} />
            )}
          </Col>
        </Row>
      </div>
      <div className={chatType ? "h-86" : "h-80"}>
        {loading && <Loader />}

        {chatType == AI_BOT_CHAT_TYPE && !isFeedbackOpen && (
          <Row className="menu-live-chat">
            <Col>
              <span className="talk-to-ca-txt">Talk to our customer care</span>
            </Col>
            <Col>
              <Button className="live-chat" onClick={openLiveChat} type="link">
                Live chat
                <img className="live-chat-img-icon" src={Icons.live_chat} />
              </Button>
            </Col>
          </Row>
        )}
        {/* {chatType && !isFeedbackOpen && (
          <Row className="menu-live-chat">
            <Col>
              {chatType == LIVE_CHAT_TYPE ? (
                <Button
                  className="main-menu"
                  type="link"
                  icon={<LeftOutlined />}
                  onClick={gotoMainMenu}
                  disabled={isCreatingLiveChat}
                >
                  Main Menu
                </Button>
              ) : (
                <span>Talk to our customer care</span>
              )}
            </Col>
            {chatType != LIVE_CHAT_TYPE && (
              <Col>
                <Button
                  className="live-chat"
                  onClick={openLiveChat}
                  type="link"
                >
                  Live chat
                  <img className="live-chat-img-icon" src={Icons.live_chat} />
                </Button>
              </Col>
            )}
          </Row>
        )} */}

        {showPrompt && (
          <div className="chat-prompt-overlay">
            <div className="chat-prompt-overlay-content">
              <Row justify="center" className="prompt-close-txt">
                <Col span={15} className="pt-12 pb-12">
                  Are you sure to close this chat?
                </Col>
              </Row>
              <Row
                justify="center"
                gutter={10}
                className="chat-prompt-btns-section"
              >
                <Space>
                  <Button
                    className="chat-prompt-no-btn"
                    onClick={() => setShowPrompt(false)}
                  >
                    No
                  </Button>
                  <Button
                    className="chat-prompt-yes-btn"
                    onClick={closeLiveChatWindow}
                  >
                    Yes
                  </Button>
                </Space>
              </Row>
            </div>
          </div>
        )}

        {isFeedbackOpen && (
          <ChatFeedback chatId={aiBotChatId} handleClose={handleClose} />
        )}

        {!chatType && !isFeedbackOpen && !isAiBotChatExist && (
          <div className="chat-questions">
            <p className="question-chat">
              Hello, ask me a question or select one below.
            </p>
            <span className="help-question-chat">How can we help you?</span>
          </div>
        )}

        {isAiBotChatExist && (
          <div className="chat-exist-container">
            <Row justify="center" className="chat-exist-txt">
              <Col span={21} className="p-12 text-center">
                Looks like you already have an active chat session.
              </Col>
            </Row>
            <Row justify="center" className="chat-open-txt">
              <Col span={21} className="ptb-16 prl-12">
                Would you like to open a new chat?
              </Col>
            </Row>
            <Row justify="center">
              <Button
                className="start-new-chat-btn"
                onClick={() => startAiBotChat(null)}
              >
                Yes
              </Button>
              <Button
                className="start-new-chat-no-btn mtb-16"
                onClick={closeChatWindow}
              >
                No
              </Button>
            </Row>
          </div>
        )}

        {!chatType && !isFeedbackOpen && !isAiBotChatExist && (
          <>
            <FAQOptionsList
              faqDetails={
                faqDetails || retainedAiBotChatDetails?.faqOptionsList
              }
              setSltdFAQOption={setSltdFAQOption}
              openAiBotChat={openAiBotChat}
            />
            <div className="ask-question-div">
              <Button onClick={openAiBotChat} className="ask-question-chat-btn">
                Ask Question
              </Button>
            </div>
          </>
        )}

        {chatType == AI_BOT_CHAT_TYPE && !isFeedbackOpen && (
          <AIBotChat
            isAiBotChatOpen={isAiBotChatOpen}
            chatDetailsBckupRef={chatDetailsBckupRef}
            retainedAiBotChatData={retainedAiBotChatDetails?.aiBotChatData}
            faqDetails={faqDetails || retainedAiBotChatDetails?.faqOptionsList}
            chatId={aiBotChatId}
            sltdFAQOption={sltdFAQOption}
          />
        )}

        {chatType == LIVE_CHAT_TYPE && (
          <PatientConversation
            gotoMainMenu={gotoMainMenu}
            chatType={chatType}
            isLiveChatOpen={isLiveChatOpen}
            chatDetails={chatDetails}
            updateChatId={updateLiveChatId}
            updateCareAdminName={updateCareAdminName}
            updateChatClose={updateLiveChatClose}
            updateChatInit={updateLiveChatInit}
            clearChatDetails={clearChatDetails}
            closeChat={closeLiveChat}
          />
        )}
      </div>
    </div>
  );
};

export default PatientChatHomePage;
